import React from 'react'

import { AsyncSelect } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import * as ProductosCrud from 'services/producto.service'

const FilaBusquedaTemplate = ({ flagPermitirVentaSinStock, esFilaActiva, tipoProducto, seleccionarProductoViaBusquedaHandler, idListaPrecio }) => {
  const __adminContext = React.useContext(AdminContext)
  const busquedaRef = React.useRef({})
  const __zariContext = React.useContext(ZariContext)

  const loadProductosSelect = (inputValue, resolve) => {
    ProductosCrud.obtenerAsVentasSelect2({
      busqueda: inputValue,
      idListaPrecio: idListaPrecio,
      tipo: tipoProducto
    }).then(({ data }) => resolve(data))
  }

  const stockValidation = (productoSeleccionado) => {
    if (productoSeleccionado.stock <= 0 && !flagPermitirVentaSinStock) {
      busquedaRef.current.value = null
      busquedaRef.current.label = ''
      __zariContext.snack('error', 'La compañia actual no tiene permitido la venta sin stock')
      return
    } else {
      seleccionarProductoViaBusquedaHandler(productoSeleccionado)
    }
  }

  return (
    <AsyncSelect
      ref={busquedaRef}
      selectId='productoSelect'
      loadOptions={loadProductosSelect}
      onChange={stockValidation}
      defaultMenuIsOpen={esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
      autoFocus={esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
    />
  )
}

export default React.memo(FilaBusquedaTemplate)
